import React from "react";
import { LoginPage } from "./pages/LoginPage";
import Layout from "./routes/Layout";
import { Routes, Route } from "react-router-dom";
import ProtectedRoute from "./routes/ProtectedRoute";
import LoginRoute from "./routes/LoginRoute";
import Toast from "./components/addons/Toast";
import { useSelector } from "react-redux";
import { RootState } from "./store/store";
import { NotFoundPage } from "./pages/NotFoundPage";
import { ForbiddenPage } from "./pages/ForbiddenPage";
import ProtectedAccess from "./routes/ProtectedAccess";
import SuperAdminRoute from "./routes/SuperAdminRoute";
import { Navigate } from "react-router-dom";
import { ThreeDView } from "./components/files/3DView";
import ChartCollection from "./components/files/Charts";
import { UserSettingsPage } from "./pages/UserSettingsPage";
import { UsersPage } from "./pages/UsersPage";
import { SuperAdminUsersPage } from "./pages/SuperAdminUsersPage";
import { SuperAdminCitiesPage } from "./pages/SuperAdminCitiesPage";
import { CityViewPage } from "./pages/CityViewPage";
import CityFilesPage from "./pages/CityFilesPage";
import { ProjectsPage } from "./pages/ProjectsPage";
import { CitiesPage } from "./pages/CitiesPage";
import { CreateProjectPage } from "./pages/CreateProjectPage";

import { GIS } from "./GIS/GIS";

import { ProjectPage } from "./pages/ProjectPage";
import { CreateAlternativePage } from "./pages/CreateAlternativePage";
import { UpdateAlternativePage } from "./pages/UpdateAlternativePage";
import { UpdateProjectPage } from "./pages/UpdateProjectPage";
import { CitySettingsPage } from "./pages/CitySettingsPage";
import { CityParametersManagementPage } from "./pages/CityParametersManagementPage";
import { GeneralParametersManagementPage } from "./pages/GeneralParametersManagementPage";

const App: React.FC = () => {
  const toastMessage = useSelector(
    (state: RootState) => state.system.toastMessage
  );
  const toastType = useSelector((state: RootState) => state.system.toastType);
  const toastTitle = useSelector((state: RootState) => state.system.toastTitle);

  return (
    <>
      <Routes>
        <Route element={<Layout />}>
          <Route element={<ProtectedAccess />}>
            <Route element={<ProtectedRoute />}>
            <Route
                path="/:entityName/user/settings"
                element={<UserSettingsPage />}
              />
            </Route>
            <Route path="/:entityName/cities" element={<CitiesPage/>}/>
            <Route path="/:entityName/city" element={<CityViewPage/>}/>
            <Route path="/:entityName/managment/users" element={<UsersPage/>}/>
            {/* City Parameters - accessible by both super_admin and admin */}
            <Route path="/:entityName/managment/city-parameters/:cityId" element={<CityParametersManagementPage/>}/>
            <Route path="/:entityName/managment/city-parameters" element={<SuperAdminCitiesPage cityParametersMode={true} />}/>
            <Route element={<SuperAdminRoute />}>
              <Route path="/:entityName/managment/super-admin-users" element={<SuperAdminUsersPage/>}/>
              <Route path="/:entityName/managment/cities" element={<SuperAdminCitiesPage/>}/>
              <Route path="/:entityName/managment/city-settings" element={<CitySettingsPage/>}/>
              <Route path="/:entityName/managment/general-parameters" element={<GeneralParametersManagementPage/>}/>
            </Route>
            <Route path="/:entityName/outline_plans" element={<CityFilesPage/>}/>
            <Route path="/:entityName/users" element={<UsersPage/>}/>
            <Route path="/:entityName/projects/:cityId?" element={<ProjectsPage/>}/>
            <Route path="/:entityName/projects/create/:cityId" element={<CreateProjectPage/>}/>
            <Route path="/:entityName/project/:cityId/:projectId" element={<ProjectPage/>}/>
            <Route path="/:entityName/project/:cityId/:projectId/update" element={<UpdateProjectPage/>}/>
            <Route path="/:entityName/project/:cityId/:projectId/alternative/create" element={<CreateAlternativePage/>}/>
            <Route path="/:entityName/project/:cityId/:projectId/alternative/:alternativeId/update" element={<UpdateAlternativePage/>}/>
          </Route>
          <Route element={<LoginRoute />}>
            <Route path="/:entityName" element={<LoginPage />} />
          </Route>
          <Route path="/3d" element={<ThreeDView/>}/>
          <Route path="/charts" element={<ChartCollection/>}/>
          <Route path="/:entityName/managment/data" element={<></>}/>
          <Route path="/404" element={<NotFoundPage />} />
          <Route path="/403" element={<ForbiddenPage />} />
          <Route path="*" element={<Navigate to="/404" replace />} />
        </Route>
      </Routes>
      <Toast
        key={Date.now()}
        type={toastType}
        message={toastMessage}
        customTitle={toastTitle}
        className="fixed right-5 z-50"
      />
    </>
    // TODO ADD PROTECTED
  );
};

export default App;
